
export const ValidationConstants = {
  
  Account: {
    NameMinLength: 2,
    NameMaxLength: 100,
    MinBalance: 0,
    MaxBalance: 1_000_000_000,
  },

  
  User: {
    EmailMaxLength: 256,
    PasswordMinLength: 6,
    PasswordMaxLength: 100,
    NameMaxLength: 100,
  },

  
  Auth: {
    TokenMaxLength: 500,
  },

  
  Category: {
    NameMinLength: 2,
    NameMaxLength: 50,
  },

  
  Receipt: {
    NameMinLength: 1,
    NameMaxLength: 100,
    AccountIdMaxLength: 36,
  },

  
  ReceiptPosition: {
    NameMinLength: 1,
    NameMaxLength: 100,
    MaxAmount: 1_000_000,
    CategoryIdMaxLength: 36,
  },

  
  RecurringExpense: {
    NameMinLength: 2,
    NameMaxLength: 100,
    MaxAmount: 1_000_000_000,
  },

  
  Budget: {
    NameMinLength: 2,
    NameMaxLength: 100,
    MinAmount: 0,
    MaxAmount: 1_000_000_000,
    MaxCategoriesCount: 50,
    MaxPeriodYears: 5,
    StartDateMinYearsAgo: 10,
    StartDateMaxYearsInFuture: 5,
    MaxDecimalPlaces: 2,
    DecimalTolerance: 0.01,
  },

  
  MonthlyPlan: {
    ItemNameMinLength: 1,
    ItemNameMaxLength: 100,
    MaxAmount: 1_000_000_000,
    MaxItemsCount: 50,
  },

  
  General: {
    GuidStringLength: 36,
    ForbiddenChars: ['<', '>', '"', '&', "'"] as const,
  },
} as const;


export const ValidationUtils = {
  
  containsForbiddenChars: (value: string): boolean => {
    return ValidationConstants.General.ForbiddenChars.some(char => value.includes(char));
  },

  
  isValidEmail: (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },

  
  hasDigit: (password: string): boolean => {
    return /\d/.test(password);
  },

  
  isValidName: (name: string): boolean => {
    if (!name.trim()) return true;
    return /^[a-zA-ZÀ-ÿĀ-žА-я\s]+$/.test(name);
  },

  
  isValidGuid: (guid: string): boolean => {
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return guidRegex.test(guid);
  },

  
  hasValidDecimalPlaces: (value: number, maxPlaces: number = ValidationConstants.Budget.MaxDecimalPlaces): boolean => {
    const decimalPart = value.toString().split('.')[1];
    return !decimalPart || decimalPart.length <= maxPlaces;
  },

  
  isReasonableStartDate: (date: Date): boolean => {
    const now = new Date();
    const minDate = new Date(now.getFullYear() - ValidationConstants.Budget.StartDateMinYearsAgo, now.getMonth(), now.getDate());
    const maxDate = new Date(now.getFullYear() + ValidationConstants.Budget.StartDateMaxYearsInFuture, now.getMonth(), now.getDate());
    
    return date >= minDate && date <= maxDate;
  },

  
  isValidDateRange: (startDate: Date, endDate: Date): boolean => {
    const maxPeriodMs = 365 * ValidationConstants.Budget.MaxPeriodYears * 24 * 60 * 60 * 1000;
    return (endDate.getTime() - startDate.getTime()) <= maxPeriodMs;
  },
};
